module.exports = "<div class=\"back\"\r\n     (click)=\"back()\"><i class='fas fa-caret-left'></i>&nbsp;&nbsp;Back</div>\r\n"